import {BMTheme} from "../../../BMTheme";

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  tabStyle: {
    paddingLeft: "1em",
    paddingRight: "1em"
  },
  headerSectionStyle: {
    padding: "1em",
    borderBottom: "1px solid #e0e0e0",
    fontWeight: "bold"
  },
  inputStyle: {
    paddingRight: "4em",
    booleanInput: {
      width: "20em",
      marginTop: "1.5em"
    },
    longBooleanInput: {
      width: "28em",
      marginTop: "1.5em"
    },
    lastInput: {
      marginBottom: "3em"
    }
  },
  pickerStyle: {
    paddingLeft: "1em"
  },
  labelStyle: {
    float: "left",
    marginRight: "2%",
    paddingLeft: "1em"
  },
  containerInput: {
    float: "left",
    marginRight: "2%"
  },
  titleStyle: {
    textTransform: "capitalize"
  },
  clearFloatContainer: {
    clear: "both"
  },
  headerContainer: {
    marginTop: 45,
    marginBottom: -10,
    padding: 0
  },
  textFieldContainer: {
    marginTop: 45
  },
  textStyle: {
    fontSize: "13px",
    textTransform: "uppercase"
  },
  latLngContainer: {
    margin: 5,
    padding: 0,
    fontSize: "10px",
    color: BMTheme.gmaps.latLngContainer.color
  },
  lanLngStyle: {
    float: "left",
    fontSize: "10px",
    margin: 0,
    padding: 0,
    height: "20px",
    lineHeight: 0
  },
  addressInputStyle: {
    width: "37em",
    float: "left"
  },
  latLngInputStyle: {
    borderBottom: "none"
  },
  faceBookInputStyle: {
    width: "42em",
    paddingBottom: "3em"
  },
  validationStyle: {
    color: BMTheme.formValidation.color,
    position: "relative",
    top: 0,
    left: 37,
    width: "20em",
    margin: 0,
    paddingTop: 0,
    fontSize: "90%"
  },
  locationSearchInput: {
    container: {
      position: "absolute",
      bottom: "26em",
      left: "12em"
    },
    input: {
      boxSizing: `border-box`,
      border: `1px solid transparent`,
      width: `240px`,
      height: `32px`,
      marginTop: `17px`,
      marginLeft: `20px`,
      padding: `0 12px`,
      paddingRight: "25px",
      borderRadius: `3px`,
      boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
      fontSize: `14px`,
      outline: `none`,
      textOverflow: `ellipses`
    },
    button: {
      boxSizing: `border-box`,
      backgroundColor: BMTheme.gmaps.locationSearchInput.button.backgroundColor,
      border: `1px solid transparent`,
      marginLeft: `-25px`,
      outline: `none`,
      textOverflow: `ellipses`
    },
    loading: {
      backgroundColor: BMTheme.gmaps.locationSearchInput.loading.backgroundColor,
      fontSize: "13px",
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 5,
      paddingBottom: 5
    },
    suggestionsContainer: {
      boxSizing: `border-box`,
      border: `1px solid transparent`,
      width: `240px`,
      height: `32px`,
      marginLeft: `20px`,
      borderRadius: `3px`,
      fontSize: `14px`,
      outline: `none`,
      textOverflow: `ellipses`
    },
    suggestions: {
      selected: {
        backgroundColor: BMTheme.gmaps.locationSearchInput.suggestions.backgroundColorSelected,
        color: BMTheme.gmaps.locationSearchInput.suggestions.colorSelected,
        cursor: "pointer",
        fontSize: "13px",
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5
      },
      other: {
        backgroundColor: BMTheme.gmaps.locationSearchInput.suggestions.backgroundColorOther,
        cursor: "pointer",
        fontSize: "13px",
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/style.js